/**
 * Based on the script 'responsive-menu.js' taken from the Infinity Pro theme and modified to use
 * font awesome instead of ionicons
 */

(function ( document, $ ) {
	'use strict';

	var infinity                      = {};
	const mobileToggle                = $( '#mobile-menu-toggle' );
	const mobileMenu                  = $( '#menu-mobile' )
	// This one stays as a string because it's used as a property as well as an ID.
	var subMenuButtonClass    = 'mobile-sub-menu-toggle';
	const mobileIndividualsTabContent = $( '#nav-mobile .for-individuals' );
	const mobileBusinessTabContent    = $( '#nav-mobile .for-business' );
	const mobileTabContentContainer   = $( '#nav-mobile .tab-content' );
	const mobileBusinessTab           = $( '#nav-mobile .tab-business' );
	const mobileGeneralTab            = $( '#nav-mobile .tab-general' );

	infinity.init = function () {
		var toggleButtons = {
			// Assign the fa class; the actual icons are done via css
			submenu: $(
				'<button />',
				{
					'class'        : subMenuButtonClass,
					'aria-expanded': false,
					'aria-pressed' : false,
					'role'         : 'button'
				}
			)
			.append( '<i class="fa"></i>' )
			.append(
				$(
					'<span />',
					{
						'class': 'screen-reader-text',
						text   : infinity.params.subMenu
					}
				)
			)
		};



		$( window ).on( 'resize.infinity', _doResize ).triggerHandler( 'resize.infinity' );
		mobileToggle.on( 'click', function ( event ) {
			event.stopPropagation();
			_mobileMenuToggle();
		} );
		$( '.' + subMenuButtonClass ).on( 'click.infinity-subbutton', _submenuToggle );
	}

	// Change Skiplinks and Superfish
	function _doResize() {
		var buttons = $( 'button[id^=mobile-]' ).attr( 'id' );
		if ( typeof buttons === 'undefined' ) {
			return;
		}
		_changeSkipLink( buttons );
		_maybeClose( buttons );
	}

	/**
	 * action to happen when the mobile menu button is clicked
	 */
	function _mobileMenuToggle() {
		// set our 'this' manually to account for all places this function is called
		var $this = mobileToggle;

		_toggleAria( $this, 'aria-pressed' );
		_toggleAria( $this, 'aria-expanded' );
		//resetMobileTabs( 0 );
		$this.toggleClass( 'activated' );

		// This is for a11y
		mobileMenu.attr( 'hidden', function ( _, attr ) {
			return !attr;
		} );
		// This is for styling
		mobileMenu.slideToggle( 'fast' );
	}

	/**
	 * action for submenu toggles
	 */
	function _submenuToggle() {

		var $this  = $( this ),
		    others = $this.closest( '.menu-item' ).siblings();
		_toggleAria( $this, 'aria-pressed' );
		_toggleAria( $this, 'aria-expanded' );
		$this.toggleClass( 'activated' );
		$this.next( '.sub-menu' ).slideToggle( 'fast' );

		others.find( '.' + subMenuButtonClass ).removeClass( 'activated' ).attr( 'aria-pressed', 'false' );
		others.find( '.sub-menu' ).slideUp( 'fast' );

	}


	/**
	 * modify skip links to match mobile buttons
	 */
	function _changeSkipLink( buttons ) {
		var startLink = 'genesis-nav',
		    endLink   = 'mobile-genesis-nav';
		if ( 'none' === _getDisplayValue( buttons ) ) {
			startLink = 'mobile-genesis-nav';
			endLink   = 'genesis-nav';
		}
		$( '.genesis-skip-link a[href^="#' + startLink + '"]' ).each(
			function () {
				var link = $( this ).attr( 'href' );
				link     = link.replace( startLink, endLink );
				$( this ).attr( 'href', link );
			}
		);
	}

	function _maybeClose( buttons ) {
		if ( 'none' !== _getDisplayValue( buttons ) ) {
			return;
		}
		$( '.menu-toggle, .sub-menu-toggle' )
		.removeClass( 'activated' )
		.attr( 'aria-expanded', false )
		.attr( 'aria-pressed', false );
		$( 'nav, .sub-menu' )
		.attr( 'style', '' );
	}

	/**
	 * generic function to get the display value of an element
	 * @param  {id} $id ID to check
	 * @return {string}     CSS value of display property
	 */
	function _getDisplayValue( $id ) {
		var element = document.getElementById( $id ),
		    style   = window.getComputedStyle( element );
		return style.getPropertyValue( 'display' );
	}

	/**
	 * Toggle aria attributes
	 * @param  {button} $this     passed through
	 * @param  {aria-xx} attribute aria attribute to toggle
	 * @return {bool}           from _ariaReturn
	 */
	function _toggleAria( $this, attribute ) {
		$this.attr(
			attribute,
			function ( index, value ) {
				return 'false' === value;
			}
		);
	}


	/**
	 * Handles closing the dropdowns when the Escape Key is pressed.
	 *
	 * @param  event
	 * @return void
	 */
	function _handleEscKey( event ) {
		let { keyCode }      = event;
		let isDropdownActive = mobileMenu.is( ':visible' );
		if ( 27 === keyCode && isDropdownActive ) {
			mobileToggle.toggleClass( 'activated' );
			mobileMenu.slideToggle( 'fast' ); // Toggle visibility
		}
	}


	/**
	 * Handles click events when clicking outside of shown mobile menu.
	 * This helps with user experience and closes dropdown when
	 * interacting with other UI
	 *
	 * @param event
	 * @return void
	 */
	function _handleClickOutside( event ) {
		const elementClicked   = event.target;
		const isDropdownActive = mobileMenu.is( ':visible' );
		if ( !mobileMenu.find( elementClicked ).length && isDropdownActive && !$( elementClicked ).is( '#mobile-menu-toggle' ) ) {
			mobileToggle.toggleClass( 'activated' );
			mobileMenu.attr( 'hidden', true ); // Remove the hidden attribute
			mobileMenu.slideToggle( 'fast' ); // Toggle visibility
		}
	}


	/**
	 * The Seal section has to be copied out of the primary desktop mega menu and
	 * pasted into its home in the mobile menu. Both are the same, so we choose wwad.
	 */
	function relocateSeal() {
		let sealData      = $( '#nav-primary ul.seal' ).first();
		let sealTarget    = $( '#nav-mobile li.seal-mobile' ).first();
		let sealDataHtml  = sealData.html();
		let sealContainer = $( '<ul></ul>' ).append( sealDataHtml );
		sealTarget.html( sealContainer );
	}


	/**
	 * Together these next four function control the tabs.
	 */

	/**
	 * Initialize the tabs. Called at startup.
	 */
	function createMobileTabs() {
		// Find the mega chunks inserted by MegaMenu->insert_chunks
		prepareTabContent();
		resetMobileTabs( 0 );
	}


	/**
	 * Manipulates the DOM for each mega sub menu.
	 */
	function prepareTabContent() {
		// Remove the first <a>, which is the (redundant) label from the parent menu item
		mobileIndividualsTabContent.children( 'a' ).first().remove();
		mobileBusinessTabContent.children( 'a' ).first().remove();
	}


	/**
	 * Resets the tabs by emptying whatever tab was active, and re-loading the
	 * correct tab for the View.
	 *
	 * Called:
	 *    - When page loads
	 *    - When menu closes
	 */
	function resetMobileTabs( speed ) {
		// First remove the content from the tab container
		mobileTabContentContainer.empty();

		// Then insert content based on View (ra_view)
		if ( 'business' === ra_view ) {
			activateMobileTab( 'business', speed );
		} else {
			activateMobileTab( 'general', speed );
		}
	}


	/**
	 * Called when a tab is clicked
	 */
	function activateMobileTab( tabId, speed ) {
		// In case the language switcher is open, close it
		$( '#nav-mobile .wpml-submenu' ).slideUp();

		if ( 'business' === tabId ) {
			// Some bling. Fade out the container.
			mobileTabContentContainer.fadeOut( speed, function () {

				// Copy the content of the tab from the insertion point into the tab content container
				mobileTabContentContainer.html( mobileBusinessTabContent.clone() );

				// fade it back in
				mobileTabContentContainer.fadeIn( speed );

				// Set the tab classes accordingly
				mobileBusinessTab.addClass( 'tab-active' );
				mobileGeneralTab.removeClass( 'tab-active' );

				// These mega menu sliders have to be set up here because it seems like the act of slideToggle
				// resets all applied actions
				$( '#nav-mobile .menu-item-cert' ).on( 'click', function () {
					$( '#nav-mobile .mega-menu-cert' ).slideToggle();
					$(this).toggleClass( 'mega-open' );
				} );
			} );
		} else {
			mobileTabContentContainer.fadeOut( speed, function () {
				mobileTabContentContainer.html( mobileIndividualsTabContent.clone() );
				mobileTabContentContainer.fadeIn( speed );
				mobileBusinessTab.removeClass( 'tab-active' );
				mobileGeneralTab.addClass( 'tab-active' );

				$( '#nav-mobile .menu-item-wwad' ).on( 'click', function () {
					$( '#nav-mobile .mega-menu-wwad' ).slideToggle();
					$(this).toggleClass( 'mega-open' );
				} );

				$( '#nav-mobile .menu-item-wycd' ).on( 'click', function () {
					$( '#nav-mobile .mega-menu-wycd' ).slideToggle();
					$(this).toggleClass( 'mega-open' );
				} );

				// THis seems to be not needed, but I'll keep it here for now.
				// If you're reading this and it is after September 2024, you can delete this.
				//$('#nav-mobile .menu-item-wycd a').click(function(event) {
	      //  event.preventDefault(); // Prevents default anchor behavior
	      //  event.stopPropagation(); // Prevents event propagation
			  //  $('#nav-mobile .mega-menu-wycd').slideToggle();
				//});
			} );
		}
		mobileTabContentContainer.removeClass( 'for-individuals' );
		mobileTabContentContainer.removeClass( 'for-business' );
	}

	/**
	 * By default, the slideUp and toggle stuff from jQuery applied display: block; we need
	 * display: flex, which is what this does.
	 * Basically: el.slideToggle() but using flex
	 * @param selector
	 * @param duration
	 * @return {*|jQuery|HTMLElement}
	 */
	function flexSlideToggle(selector, duration = 400) {
	  const $element = $(selector);
	  const isVisible = $element.is(':visible');

	  if (isVisible) {
	    flexSlideUp(selector);
	  } else {
	    $element.css({
	      display: 'flex',
	      height: 0,
	      overflow: 'hidden'
	    }).show();

	    const autoHeight = $element.css('height', 'auto').height();
	    $element.height(0).animate({height: autoHeight}, duration, function() {
	      $(this).css({
	        height: 'auto',
	        overflow: ''
	      });
	    });
	  }

	  return $element;
	}

	/**
	 * Basically: el.slideUp() but using flex
	 * @param selector
	 * @param duration
	 * @return {*|jQuery|HTMLElement}
	 */
	function flexSlideUp(selector, duration = 400) {
	  const $element = $(selector);

	  // Only perform animation if element is visible
	  if ($element.is(':visible')) {
	    $element.css('display', 'flex')
	      .animate({height: 0}, duration, function() {
	        $(this).hide();
	      });
	  }

	  return $element;
	}


	$( document ).ready(function () {

		// Set the hidden attribute on all menus that start hidden
		//$('ul#nav-mobile').attr( 'hidden', true );

		relocateSeal();

		mobileBusinessTabContent.children( 'a' ).first().remove();
		mobileTabContentContainer.html( mobileBusinessTabContent.clone() );

		$( '#nav-mobile .menu-item-cert' ).on( 'click', function (event) {
			$( '#nav-mobile .wpml-submenu' ).slideUp();
			$( '#nav-mobile .wpml-language-selector' ).removeClass( 'activated' );

			//$( '#nav-mobile .mega-menu-cert' ).slideToggle();
			flexSlideToggle( $( '#nav-mobile .mega-menu-cert' ) );
			$(this).toggleClass( 'mega-open' );
			event.stopPropagation();
		} );

		$( '#nav-mobile .wpml-language-selector' ).on( 'click', function (event) {
			flexSlideUp( $( '#nav-mobile .mega-menu-cert' ) );
			//$( '#nav-mobile .mega-menu-cert' ).slideUp();
			$( '#nav-mobile .menu-item-cert' ).removeClass( 'mega-open' );

			$( '#nav-mobile .wpml-submenu' ).slideToggle();
			$( this ).toggleClass( 'activated' );
			event.stopPropagation();
			//event.preventDefault();
		} );

		// If esc is clicked, close the menu
		document.addEventListener( 'keydown', _handleEscKey, false );

		// If anything outside the menu is clicked, close the menu
		document.addEventListener( 'click', _handleClickOutside, false );

		// Localization as passed through via php. See setup.php
		infinity.params = typeof InfinityL10n === 'undefined' ? '' : InfinityL10n;

		if ( typeof infinity.params !== 'undefined' ) {
			infinity.init();
		}

	});

})( document, jQuery );
